import React from 'react';
import {
  FileSearch,
  ImageIcon,
  PlaySquare,
  Table2,
  Presentation,
  LayoutDashboard,
} from 'lucide-react';
import './OpenClawUseCases.css';

const USE_CASES = [
  {
    icon: <FileSearch size={20} />,
    title: 'Research pipeline → formatted PDF',
    body: 'Your research agent sources data. Delegate the write-up to CellCog. Get a 2-page PDF back with citations, charts, and formatting.',
  },
  {
    icon: <ImageIcon size={20} />,
    title: 'Content workflow → hero image',
    body: 'Your marketing agent drafts a blog post. Delegate the hero image with style + dimension specs. Get a ready-to-publish PNG or WebP.',
  },
  {
    icon: <PlaySquare size={20} />,
    title: 'Support ticket → explainer video',
    body: 'Your support agent handles a "how do I…" ticket. Delegate a 30-second explainer video to CellCog. Get a shareable MP4.',
  },
  {
    icon: <Table2 size={20} />,
    title: 'Financial analysis → Excel model',
    body: 'Your data agent pulls ticker data. Delegate the Excel model with formulas, charts, and formatted sheets. Get a .xlsx file.',
  },
  {
    icon: <Presentation size={20} />,
    title: 'Sales outreach → personalized deck',
    body: 'Your CRM agent identifies a prospect. Delegate a 5-slide personalized pitch deck. Get a .pptx file.',
  },
  {
    icon: <LayoutDashboard size={20} />,
    title: 'Ops agent → live dashboard',
    body: 'Your ops agent monitors metrics. Delegate an interactive HTML dashboard. Get a URL your team can share instantly.',
  },
];

const OpenClawUseCases = () => {
  return (
    <section className="openclaw-uses">
      <div className="section">
        <div className="section-eyebrow">What OpenClaw agents delegate</div>
        <h2 className="section-title display-font">
          Six real patterns. One execution layer.
        </h2>
        <p className="section-subtitle">
          Your agents stay focused on orchestration. CellCog handles the
          deliverables. Everything below is a working pattern on the
          OpenClaw network today.
        </p>

        <div className="openclaw-uses__grid">
          {USE_CASES.map((u) => (
            <div key={u.title} className="openclaw-uses__card">
              <div className="openclaw-uses__card-icon">{u.icon}</div>
              <h3 className="openclaw-uses__card-title">{u.title}</h3>
              <p className="openclaw-uses__card-body">{u.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OpenClawUseCases;
